/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const CodeIcon = createIcon(
  '0 0 20 20',
  <path d="M8.35 17H6.206L11.65 3h2.146zM6.207 7.207 3.414 10l2.793 2.793-1.414 1.414L.586 10l4.207-4.207zM19.414 10l-4.207 4.207-1.414-1.414L16.586 10l-2.793-2.793 1.414-1.414z" />,
);
